import { Injectable, OnDestroy } from '@angular/core';
import { createClient, RealtimeChannel, RealtimePostgresChangesPayload, SupabaseClient } from '@supabase/supabase-js';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RealtimeService implements OnDestroy {
    private supabase: SupabaseClient = createClient(environment.supabaseUrl, environment.supabaseKey);
    private channel: RealtimeChannel | null = null;

    private reportUpdated$ = new Subject<{ id: string; status: string; resolvedByUserId: string | null }>();
    reportUpdated = this.reportUpdated$.asObservable();

    subscribeToReports(): void {
        this.channel = this.supabase
            .channel('reports-moderation')
            .on(
                'postgres_changes',
                { event: 'UPDATE', schema: 'public', table: 'reports' },
                (payload: RealtimePostgresChangesPayload<{ id: string; status: string; resolved_by_user_id: string | null }>) => {
                    const updated = payload.new as { id: string; status: string; resolved_by_user_id: string | null };
                    this.reportUpdated$.next({
                        id: updated.id,
                        status: updated.status,
                        resolvedByUserId: updated.resolved_by_user_id
                    });
                }
            )
            .subscribe();
    }

    unsubscribe(): void {
        this.channel?.unsubscribe();
        this.channel = null;
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }
}